// @ts-nocheck
import { authenticated, api } from './index';

export const createCostCenter = (payload) =>
  authenticated(api).post('/costcenter/', payload);

export const getCostCenter = (params) =>
  authenticated(api).get('/costcenter/', { params });

export const updateCostCenter = (params, payload) =>
  authenticated(api).put(`/costcenter/${params.costCenterId}/`, payload);

export const deleteCostCenter = (params) =>
  authenticated(api).delete(`/costcenter/${params.id}/`);
